import { mutatorAction } from 'satcheljs';
import getWeatherOption from '../store/store';
export default mutatorAction('setShowWeatherOption', function setShowWeatherOption(showWeatherStatus) {
    var optionState = getWeatherOption();
    optionState.weatherEnabled = showWeatherStatus
        ? 2 /* Enabled */
        : 1 /* Disabled */;
});
//# sourceMappingURL=setShowWeatherOption.js.map